__turbopack_context__.v({
  "PageChange": "PageChange-module__gu_atW__PageChange",
  "btnText": "PageChange-module__gu_atW__btnText",
  "button": "PageChange-module__gu_atW__button",
  "changeButton": "PageChange-module__gu_atW__changeButton",
  "error": "PageChange-module__gu_atW__error",
  "icon": "PageChange-module__gu_atW__icon",
  "input": "PageChange-module__gu_atW__input",
  "left": "PageChange-module__gu_atW__left",
  "pageForm": "PageChange-module__gu_atW__pageForm",
  "right": "PageChange-module__gu_atW__right",
  "selectButton": "PageChange-module__gu_atW__selectButton",
  "text": "PageChange-module__gu_atW__text",
});
